import type Phaser from 'phaser';
import { App } from '@capacitor/app';
import type { BurnTransitionScene } from '../scenes/BurnTransitionScene';
import { gameState } from '../state/GameState';

export function attachNativeBackButton(game: Phaser.Game): void {
  App.addListener('backButton', () => handleBack(game));
}

function handleBack(game: Phaser.Game): void {
  const sm = game.scene;

  if (sm.isActive('TokenMachine')) {
    sm.stop('TokenMachine');
    return;
  }

  // BurnTransition is registered with active:true (always running as an event
  // listener for BURN_EVENT). Only treat it as blocking when an actual burn
  // is mid-flight; otherwise back during gameplay would always early-return.
  const burn = sm.getScene('BurnTransition') as BurnTransitionScene | undefined;
  if (burn?.isPlaying()) {
    return;
  }

  if (sm.isActive('Game')) {
    // Quitting mid-run forfeits the token already spent on this run; reset
    // session state so the next play starts at level 1 with full lives.
    gameState.reset();
    sm.stop('Hud');
    sm.stop('Game');
    sm.start('Title');
    return;
  }

  void App.exitApp();
}
